module.exports = __webpack_public_path__ + "img/lottery_title.e879934f.png";